import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

// "Link each tag chip to its tag page" — carried by DynamicAppTagListElement
// (stringArray fields, hashtags being the canonical case). Defaults to Yes
// for behavior parity with the legacy hashtag chips. Production twin of the
// editor option (%/dynamic-component-editor/options/link-tags.js).
export default class LinkTags extends BaseOption {
  static userInterfaceComponent = {
    label: "Link Tags",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  };

  static defaultValue = true;
}
